import { useDispatch, useSelector } from "react-redux";
import {
  SettingsSectionWrapper1,
  SettingsSectionWrapper2,
} from "../../pageComponents/settings/style";
import {
  InvoiceButton,
  PlanDescription,
  PlanDetailWrapper,
  PlanDetailsWrapper,
  PlanName,
  PlanPrice,
  UpgradePlanButton,
  Wrapper,
} from "../planDetailsSection/style";
import { useEffect, useState } from "react";
import {
  activeSubscriptionSelector,
  isLoadingSelector,
  paymentHistoryListSelector,
} from "../../store/payment/selector";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { PaymentSagaActions } from "../../store/payment/sagas";
import { paymentHistoryListDataType } from "../../store/payment/types";
import { Box, Chip, CircularProgress, Typography } from "@mui/material";
import InvoiceModal from "./InvoiceModal";
import CancelRenewalModal from "./CancelRenewalModal";
import { ButtonText, HeaderButton1 } from "../../pageComponents/style";
import routeConstant from "../../utils/routeConstant";
import { useNavigate } from "react-router-dom";
import {AdDrawerStyledButton} from "../commonComponents/adDetails/style";
import {NavigatePrevIcon} from "../../assets/Icons";
import { format, isAfter,addYears} from 'date-fns';

const PaymentHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openInvoiceModal, setOpenInvoiceModal] = useState<boolean>(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string>();
  const [openCancelRenewalModal, setOpenCancelRenewalModal] =
    useState<string>("");
  const activePlan = useSelector(activeSubscriptionSelector);
  const paymentHistoryList = useSelector(paymentHistoryListSelector);
  const isLoading = useSelector(isLoadingSelector);

  useEffect(() => {
    dispatch(PaymentSagaActions.getPaymentHistoryList());
  }, [dispatch]);

  const handleInvoiceClick = (paymentInvoiceId: string) => {
    dispatch(PaymentSagaActions.getPaymentDetails({ id: paymentInvoiceId }));
    setOpenInvoiceModal(true);
    setSelectedInvoiceId(paymentInvoiceId);
  };

  const handleSubscriptionCancel = (id: string) => {
    dispatch(PaymentSagaActions.cancelSubscription(id));
    setOpenCancelRenewalModal("");
  };

  const getPlanStatus = (startDate: string, endDate: string): string => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const oneYearLater = addYears(start, 1);

    return isAfter(end, oneYearLater) ? 'Plan valid for Lifetime' :  `Plan expired on ${end.toLocaleDateString()}`;
  };

  const planValidForLifetime = (planRenewalDate: string): boolean => {
    const today = new Date();
    const renewalDate = new Date(planRenewalDate);

    const oneYearFromToday = addYears(today, 1);

    return isAfter(renewalDate, oneYearFromToday);
  };

  const handleRedirect = () => {
    navigate(`${routeConstant.subscription}`);
  };
  return (
    <SettingsSectionWrapper1>
      <AdDrawerStyledButton onClick={() => navigate(-1)}>
        <NavigatePrevIcon />
        Back
      </AdDrawerStyledButton>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "40vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <SettingsSectionWrapper2>
          {paymentHistoryList?.data?.length ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "1rem",
              }}
            >
              <HeaderButton1
                variant="outlined"
                size="large"
                sx={{ width: "200px" }}
                onClick={() => navigate(routeConstant.paymentLogs)}
              >
                <ReceiptIcon />
                <ButtonText>Payment Logs</ButtonText>
              </HeaderButton1>
            </Box>
          ) : (
            <Box
              sx={{
                minHeight: "40vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" color="text.secondary">
                Looks like you haven’t made a payment yet!
              </Typography>
            </Box>
          )}
          {paymentHistoryList?.data?.length > 0 &&
            paymentHistoryList?.data?.filter((lifetimePayment:paymentHistoryListDataType) => {
              return !(
                  lifetimePayment?.paymentStatus === "PENDING" &&
                  planValidForLifetime(lifetimePayment.startDate)
              );
            })?.map(
              (payment: paymentHistoryListDataType, index: number) => (
                <Wrapper key={payment._id}>
                  <PlanDetailsWrapper>
                    <PlanDetailWrapper>
                      {payment?.planStatus ? (
                        <Chip
                          label={payment?.planStatus}
                          sx={{
                            padding: "3px 7px",
                            borderRadius: "20px",
                            background: "#FAFAFA",
                            border:
                              payment?.status === "Cancelled"
                                ? "1px solid red"
                                : payment?.planStatus === "Current Plan"
                                ? "1px solid green"
                                : payment?.planStatus === "Renewal Plan"
                                ? "1px solid #1976d2"
                                : "1px solid #EAECEE",
                            color:
                              payment?.status === "Cancelled"
                                ? "red"
                                : payment?.planStatus === "Current Plan"
                                ? "green"
                                : payment?.planStatus === "Renewal Plan"
                                ? "#1976d2"
                                : "#414042",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        />
                      ) : null}
                      <PlanName>{payment.planName}</PlanName>
                      {payment?.status !== "Cancelled" &&
                      !payment?.isPaymentDone &&
                      payment?.paymentStatus === "PENDING" ? (
                        <PlanDescription>
                          Next plan renewal date{" "}
                          {new Date(payment.startDate).toLocaleDateString() ??
                            ""}
                          .
                        </PlanDescription>
                      ) : null}
                      {payment?.status !== "Cancelled" &&
                      payment?.isPaymentDone &&
                      payment?.paymentStatus === "COMPLETED" ? (
                        <PlanDescription>
                          Plan purchased on{" "}
                          {new Date(
                            payment.startDate
                          ).toLocaleDateString() ?? ""}
                          .
                        </PlanDescription>
                      ) : null}
                      {payment?.status === "Cancelled" ? (
                        <PlanDescription style={{ color: "red" }}>
                          Your plan has been cancelled. The {" "}
                          {payment?.planName
                         ? payment?.planName : ''}{" "}
                          will be continue to have access until{" "}
                          {payment?.startDate
                            ? new Date(
                                  payment?.startDate
                              ).toLocaleDateString()
                            : ""}
                          . Then, Freemium Plan will continue.
                        </PlanDescription>
                      ) : null}

                      {payment?.planEndDate ? (
                          <PlanDescription style={{ color: "red" }}>
                            {/*Plan expired on{" "}*/}
                            {getPlanStatus(payment?.startDate,payment?.planEndDate)}.
                          </PlanDescription>
                      ) : null}
                      {/*{payment?.planEndDate ? (*/}
                      {/*  <PlanDescription style={{ color: "red" }}>*/}
                      {/*    Plan expired on{" "}*/}
                      {/*    {new Date(*/}
                      {/*      payment?.planEndDate*/}
                      {/*    ).toLocaleDateString() ?? ""}*/}
                      {/*    .*/}
                      {/*  </PlanDescription>*/}
                      {/*) : null}*/}

                      {payment?.transactionRefrenceId ? (

                          <PlanPrice weight={400}>
                            Transaction ID:{" "}
                            <PlanPrice weight={700} size="1rem">
                              {payment?.transactionRefrenceId}
                            </PlanPrice>
                          </PlanPrice>
                      ):null}
                      <PlanPrice weight={400} size="0.875rem">
                        <PlanPrice weight={700} size="1rem">
                          ${payment.amount}
                        </PlanPrice>{" "}
                        / month
                      </PlanPrice>
                    </PlanDetailWrapper>

                    {payment?.status === "Completed"? (
                        <div style={{display:'flex',flexDirection:'column',gap:'1rem', alignItems:'end'}}>
                          {getPlanStatus(payment?.startDate,payment?.endDate) === 'Plan valid for Lifetime' && index === 1 ? (
                              <UpgradePlanButton onClick={handleRedirect}>
                                Upgrade Plan
                              </UpgradePlanButton>
                          ):null}

                      <InvoiceButton
                        style={{
                          cursor:
                            isLoading && selectedInvoiceId === payment._id
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => handleInvoiceClick(payment._id)}
                        disabled={isLoading && selectedInvoiceId === payment._id}
                        startIcon={
                          isLoading && selectedInvoiceId === payment._id ? (
                            <CircularProgress
                              size={16}
                              sx={{ color: "white" }}
                            />
                          ) : null
                        }
                      >
                        Invoice
                      </InvoiceButton>
                        </div> ) : null}
                    {payment?.status !== "Cancelled" && !planValidForLifetime(payment?.startDate) &&
                    payment?.planStatus === "Renewal Plan" ? (
                      <UpgradePlanButton
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpenCancelRenewalModal(payment._id)}
                      >
                        Cancel Renewal
                      </UpgradePlanButton>
                    ) : null}
                  </PlanDetailsWrapper>
                </Wrapper>
              )
            )}
        </SettingsSectionWrapper2>
      )}
      <InvoiceModal
        openInvoiceModal={openInvoiceModal}
        setOpenInvoiceModal={setOpenInvoiceModal}
      />
      <CancelRenewalModal
        handleCancelRenewal={() =>
          handleSubscriptionCancel(openCancelRenewalModal)
        }
        isLoading={isLoading}
        handleClose={() => setOpenCancelRenewalModal("")}
        open={!!openCancelRenewalModal}
      />
    </SettingsSectionWrapper1>
  );
};

export default PaymentHistory;
